/**
 * @fileoverview DELETE handler for the "/data_objects/:type_name/:object_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameObjectIdCacheKeys } from "./constants";
import type { DeleteCustomObjectsTypeNameObjectIdProps } from "./types";

export const deleteCustomObjectsTypeNameObjectId = reactQueryMutationAdapter(
  [...customObjectsTypeNameObjectIdCacheKeys],
  (props: DeleteCustomObjectsTypeNameObjectIdProps): Promise<Record<string, never>> => {
    return fetch(
      `/data_objects/${encodeURIComponent(props.typeName)}/${encodeURIComponent(props.objectId)}`,
      "DELETE",
      {},
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
